import { render, staticRenderFns } from "./ViajeTable.vue?vue&type=template&id=3825f31b"
import script from "./ViajeTable.vue?vue&type=script&lang=js"
export * from "./ViajeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports